import { GeometryType } from "@evergis/api";
import { EditGeometryType } from "../evergis/core/attributes/geometryTypes";

/**
 * Converts GeometryType enum values to compoundIconsMap keys
 *
 * compoundIconsMap expects keys: "polyline", "point", "polygon", "multipolygon", "h3grid"
 * GeometryType enum provides values like: Point, Polyline, Polygon, Multipoint, etc.
 *
 * @param geometryType - GeometryType or EditGeometryType value
 * @returns key for compoundIconsMap
 */
export function geometryTypeToIconKey(geometryType: GeometryType | EditGeometryType | string): string {
  // Handle known GeometryType enum values
  const mapping: Record<string, string> = {
    // Standard geometry types (from @evergis/api)
    [GeometryType.Point]: "point",
    [GeometryType.Polyline]: "polyline",
    [GeometryType.Polygon]: "polygon",
    [GeometryType.Multipoint]: "point",

    // Handle possible alternative names (for backward compatibility)
    Point: "point",
    LineString: "polyline",
    MultiLineString: "polyline",
    Polyline: "polyline",
    Polygon: "polygon",
    MultiPolygon: "multipolygon",
    Multipoint: "point",
    MultiPoint: "point",

    // Edit geometry types
    [EditGeometryType.Raster]: "polygon",
    [EditGeometryType.QLS]: "polygon",

    // Special case
    h3grid: "h3grid",
  };

  const result = mapping[geometryType as string];

  if (result) {
    return result;
  }

  // Fallback: convert to lowercase
  return String(geometryType).toLowerCase();
}
